"use client"
import { useCreditFormatters } from "@/hooks/use-credit-formatters"


import { Phone, CheckCircle, Clock } from "lucide-react"
import type { CallsStats as CallsStatsType } from "@/hooks/use-calls"

import { useTranslations } from "next-intl"


interface CallsStatsProps {
  stats: CallsStatsType
  showCost: boolean
}

export function CallsStats({ stats, showCost }: CallsStatsProps) {
  const { formatCredits } = useCreditFormatters()

  const tUi = useTranslations("Calls.CallsCallsStats")
  const tCommonUi = useTranslations("Common")

  if (stats.totalCalls === 0) {
    return null
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="flex items-center gap-2">
          <Phone className="w-5 h-5 text-blue-600" />
          <div>
            <div className="text-2xl font-bold text-gray-900">{stats.totalCalls}</div>
            <div className="text-sm text-gray-600"><span key={tUi("totalCalls")}>{tUi("totalCalls")}</span></div>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="flex items-center gap-2">
          <CheckCircle className="w-5 h-5 text-green-600" />
          <div>
            <div className="text-2xl font-bold text-gray-900">{stats.completedCalls}</div>
            <div className="text-sm text-gray-600"><span key={tCommonUi("completed")}>{tCommonUi("completed")}</span></div>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-orange-600" />
          <div>
            <div className="text-2xl font-bold text-gray-900">{stats.totalDurationMinutes}<span>m</span></div>
            <div className="text-sm text-gray-600"><span key={tUi("totalDuration")}>{tUi("totalDuration")}</span></div>
          </div>
        </div>
      </div>

      {showCost && (
        <div className="bg-white p-4 rounded-lg border border-gray-200">
          <div className="flex items-center gap-2">
            <div className="min-w-0">
              <div className="break-words text-2xl font-bold text-gray-900">
                {formatCredits(stats.totalCostMicrousd)}
              </div>
              <div className="text-sm text-gray-600"><span key={tUi("totalAgentCost")}>{tUi("totalAgentCost")}</span></div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
